export const goToUrl = (url: string) => {
    if (typeof window === 'object') {
        // window does not exist on BE side
        window.location.href = url;
    }
};

export const smoothScrollToTop = () => {
    if (typeof window === 'object') {
        // window does not exist on BE side
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }
};

export const getBaseUrl = () => document?.location.href.split('?')[0];

export const setDocumentTitle = (pageTitle: string, count: number) => {
    const prefix = count ? `(${count}) ` : '';
    document.title = `${prefix}${pageTitle}`;
};

export const getParamFromUrl = (paramName: string): string => {
    const urlParams = new URLSearchParams(window?.location.search);
    const paramValue = urlParams.get(paramName);
    return paramValue || '';
};
